import { render, staticRenderFns } from "./EvaluacionesAnualesTable.vue?vue&type=template&id=24108b5e&scoped=true"
import script from "./EvaluacionesAnualesTable.vue?vue&type=script&lang=js"
export * from "./EvaluacionesAnualesTable.vue?vue&type=script&lang=js"
import style0 from "./EvaluacionesAnualesTable.vue?vue&type=style&index=0&id=24108b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24108b5e",
  null
  
)

export default component.exports